import React from "react";
import classNames from "classnames";
import "@reach/menu-button/styles.css";
import { Menu, MenuButton, MenuPopover, MenuPopoverProps } from "@reach/menu-button";
import Icon from "assets/icons";
import isString from "lodash/isString";

function GlobalMenuPopover({
  width,
  children,
  position,
  className,
  menuTitle,
  fixedWidth,
  icon
}: {
  width?: number;
  menuTitle: React.ReactNode;
  className?: string;
  fixedWidth?: boolean;
  children: React.ReactChild;
  position?: MenuPopoverProps["position"];
  icon?: Icon;
}) {
  return (
    <div className={classNames("dropdown_menu_popover", className)}>
      <Menu>
        <MenuButton title={isString(menuTitle) ? menuTitle : ""}>
          {icon && <small className="dropdown_menu_popover_icon">{icon}</small>}
          <span>{menuTitle}</span>
        </MenuButton>
        <MenuPopover
          position={position}
          style={{ width: fixedWidth ? width : "" }}
          className={classNames("dropdown_menu_popover_list", className, { hasFixedWidth: fixedWidth })}>
          <div className="dropdown_menu_popover_list_container">{children}</div>
        </MenuPopover>
      </Menu>
    </div>
  );
}

export default GlobalMenuPopover;
